import styled from 'styled-components';

import { UnstyledButton } from '@components/UnstyledButton/UnstyledButton';
import { useClientEnvironment } from '@hooks/clientEnvironment';

type MainLogoProps = {
  className?: string;
  onClick?: () => void;
};
export const MainLogo = ({ className, onClick }: MainLogoProps) => {
  const { data } = useClientEnvironment();
  const logoUrl = data?.logo_url;
  if (!logoUrl) {
    return null;
  }

  if (onClick) {
    return (
      <StyledButton
        className={`main-button ${className}`}
        onClick={onClick}
        type='button'
      >
        <StyledImage src={logoUrl} className='main-image' />
      </StyledButton>
    );
  }

  return <StyledImage className={`main-image ${className}`} src={logoUrl} />;
};

const StyledButton = styled(UnstyledButton)`
  &.main-button {
    display: flex;
    width: fit-content;
    height: fit-content;
  }
`;

const StyledImage = styled.img`
  &.main-image {
    display: block;
    height: 48px;
    object-fit: contain;
    max-width: 100%;
  }
`;
